import React from 'react';
import { Gift, Mic, Headphones, FileText, Check } from 'lucide-react';
import { Section } from './ui/Section';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { useLanguage } from '../hooks/useLanguage';
export function BonusesSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  const {
    t
  } = useLanguage();
  const bonuses = [{
    icon: <Mic className="w-8 h-8" data-id="element-10" />,
    title: t('bonuses', 'b1Title'),
    value: t('bonuses', 'b1Value'),
    desc: t('bonuses', 'b1Desc'),
    image: t('bonuses', 'b1Image'),
    features: [t('bonuses', 'b1f1'), t('bonuses', 'b1f2'), t('bonuses', 'b1f3'), t('bonuses', 'b1f4')],
    footer: t('bonuses', 'b1Footer')
  }, {
    icon: <Headphones className="w-8 h-8" data-id="element-11" />,
    title: t('bonuses', 'b2Title'),
    value: t('bonuses', 'b2Value'),
    desc: t('bonuses', 'b2Desc'),
    features: [t('bonuses', 'b2f1'), t('bonuses', 'b2f2'), t('bonuses', 'b2f3')],
    footer: t('bonuses', 'b2Footer')
  }, {
    icon: <FileText className="w-8 h-8" data-id="element-12" />,
    title: t('bonuses', 'b3Title'),
    value: t('bonuses', 'b3Value'),
    desc: t('bonuses', 'b3Desc'),
    image: t('bonuses', 'b3Image'),
    features: [t('bonuses', 'b3f1'), t('bonuses', 'b3f2'), t('bonuses', 'b3f3')],
    footer: t('bonuses', 'b3Footer')
  }];
  return <Section background="gradient" id="bonuses" data-id="element-13">
      <div ref={ref} className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`} data-id="element-14">
        <div className="text-center mb-16" data-id="element-15">
          <div className="inline-flex items-center gap-2 px-4 py-1 rounded-full bg-brand-blue/10 text-brand-blue font-bold uppercase text-sm mb-4" data-id="element-16">
            <Gift className="w-4 h-4" data-id="element-17" />
            <span data-id="element-18">{t('bonuses', 'badge')}</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-brand-navy mb-4" data-id="element-19">
            {t('bonuses', 'title1')}
            <span className="text-brand-blue-light" data-id="element-20">
              {t('bonuses', 'title2')}
            </span>
          </h2>
          <p className="text-slate-500 max-w-2xl mx-auto" data-id="element-21">
            {t('bonuses', 'desc')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-22">
          {bonuses.map((bonus, idx) => <div key={idx} className="relative group bg-white p-8 rounded-xl border border-slate-200 hover:border-brand-blue transition-all duration-300 hover:shadow-[0_0_30px_rgba(13,148,136,0.15)] shadow-md" data-id="element-23">
              <div className="absolute top-0 right-0 bg-brand-blue text-white text-xs font-bold px-3 py-1 rounded-bl-lg rounded-tr-lg" data-id="element-24">
                {t('bonuses', 'free')}
              </div>

              {bonus.image ? <div className="mb-6 -mx-2 -mt-2 overflow-hidden rounded-lg" data-id="element-25">
                  <img src={bonus.image} alt={bonus.title} className="w-full h-48 object-cover rounded-lg group-hover:scale-105 transition-transform duration-500" data-id="element-26" />
                </div> : <div className="w-16 h-16 bg-gradient-to-br from-brand-blue to-brand-blue-light rounded-full flex items-center justify-center text-white mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-brand-blue/20" data-id="element-27">
                  {bonus.icon}
                </div>}

              <h3 className="text-xl font-bold text-brand-navy mb-2 font-heading uppercase tracking-wide" data-id="element-28">
                {bonus.title}
              </h3>
              <p className="text-brand-blue-light font-semibold text-sm mb-4" data-id="element-29">
                {bonus.value}
              </p>
              <p className="text-slate-500 text-sm mb-3" data-id="element-30">{bonus.desc}</p>
              <ul className="space-y-2 mb-4" data-id="element-31">
                {bonus.features.map((feature, i) => <li key={i} className="flex items-start gap-2 text-sm text-slate-700" data-id="element-32">
                    <Check className="w-4 h-4 text-brand-blue shrink-0 mt-0.5" data-id="element-33" />
                    <span data-id="element-34">{feature}</span>
                  </li>)}
              </ul>
              <p className="text-slate-400 text-xs italic leading-relaxed" data-id="element-35">
                {bonus.footer}
              </p>
            </div>)}
        </div>
      </div>
    </Section>;
}